import React from "react";
import { Box, Typography, FormControlLabel, Checkbox, Divider, Paper, Stack, Grid } from "@mui/material";

// ReviewStep now expects buildings as an array of { building, meters } objects
const ReviewStep = ({
    organizationInfo,
    buildings,
    agreeConditions,
    setAgreeConditions,
    agreeMandate,
    setAgreeMandate
}) => (
    <Box sx={{ mt: 2 }}>
        <Typography variant="h6">Review & Confirm</Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Organization Info:</strong><br />
            Name: {organizationInfo.name}<br />
            Address: {organizationInfo.address}<br />
            Contact: {organizationInfo.contact}<br />
            Email: {organizationInfo.email}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Buildings & Meters:</strong>
        </Typography>
        {buildings.length === 0 && (
            <Typography color="error" sx={{ ml: 2 }}>No buildings entered.</Typography>
        )}
        {buildings.map((b, idx) => (
            <Box key={idx} sx={{ ml: { xs: 0, sm: 2 }, mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Building {idx + 1}: {b.building.name || <span style={{ color: "#aaa" }}>Unnamed</span>}
                </Typography>
                <Typography variant="body2">
                    Address: {b.building.postalCode} {b.building.streetNumber}{b.building.addition ? ` ${b.building.addition}` : ""}<br />
                    Building Year: {b.building.buildingYear}<br />
                    Floor Size: {b.building.floorSize} m²<br />
                    Isolation Grade: {b.building.isolationGrade}<br />
                    Energy Label: {b.building.energyLabel}<br />
                    Usage: {b.building.usage}<br />
                    Rental: {b.building.rental}<br />
                    Occupancy Rate: {b.building.occupancyRate}<br />
                    Climate Type: {b.building.climateType}<br />
                    EAN13: {b.building.ean13}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
                    <strong>Meters:</strong>
                </Typography>
                {b.meters && b.meters.length > 0 ? (
                    <Grid container spacing={2}>
                        {b.meters.map((meter, mIdx) => (
                            <Grid item xs={12} sm={6} md={4} xl={2} key={mIdx}>
                                    <Stack spacing={0.5}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            <strong>EAN18:</strong> {meter.ean18}
                                        </Typography>

                                        <Typography variant="body2">
                                            <strong>Grid Operator:</strong> {meter.gridOperator}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Meter Type:</strong> {meter.meterType}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Low Rate:</strong> {meter.lowRate}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>High Rate:</strong> {meter.highRate}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Contracted Capacity:</strong> {meter.contractedCapacity}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>External Data Provider:</strong> {meter.externalDataProvider}
                                        </Typography>
                                    </Stack>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <span style={{ color: "#aaa" }}>No meters selected</span>
                )}
            </Box>
        ))}

        <Divider sx={{ my: 2 }} />

        <FormControlLabel
            control={
                <Checkbox
                    checked={agreeConditions}
                    onChange={(e) => setAgreeConditions(e.target.checked)}
                />
            }
            label="I agree to the terms and conditions."
        />
        <FormControlLabel
            control={
                <Checkbox
                    checked={agreeMandate}
                    onChange={(e) => setAgreeMandate(e.target.checked)}
                />
            }
            label="I authorize the creation of a mandate form."
        />
    </Box>
);

export default ReviewStep;